/**
 * PR-29 — Live Poll compact-mode policy.
 * Before vote: card capped at 110px tall.
 * After vote: 2.5s success toast then auto-minimize to a badge.
 */
export const POLL_MAX_PRE_VOTE_HEIGHT_PX = 110;
export const POLL_POST_VOTE_TOAST_MS = 2_500;
export const POLL_MINIMIZED_LABEL = "🗳️ Encuesta completada";